import React from 'react';

import { FEATURE_FLAGS_NAMES } from '@silverfort-nodelibs/common/utils/consts';
import { SYSTEM_MODES } from '@silverfort-nodelibs/common/utils/system-mode-config';
import useFeature from '../../hooks/featureFlags/useFeature';

import styles from './WizardWelcome.module.css';
import WelcomeWizardImg from '../../common/Images/WelcomeWizardImg.png';

const WizardWelcome = () => {
    const systemMode = useFeature(FEATURE_FLAGS_NAMES.SystemMode);

    return (
        <div id="settings-wizard-welcome-tab" className={styles.welcomeContainer}>
            <div className={styles.mainDataContainer}>
                <span id="settings-wizard-welcome-title" className={styles.welcomeHeader}>
                    Welcome to the Silverfort configuration Wizard.
                </span>
                <span id="settings-wizard-welcome-description" className={styles.welcomeBody}>
                    The Silverfort configuration wizard will guide you through the steps to setup your Silverfort system
                    quickly.<br></br> We'll take the confusion out of this process and get your system up and running
                    properly.<br></br> You can return to this wizard at any time, to adjust settings, or add additional
                    components as you expand your system.
                </span>
            </div>
            <span id="settings-wizard-welcome-image-div" className={styles.imgContainer}>
                <img className={styles.welcomeImg} src={WelcomeWizardImg} alt="" />
            </span>
            <span id="settings-wizard-welcome-settings-description" className={styles.welcomeFooter}>
                You can also go straight to the Settings pages and make adjustments there. Don't forget to save any
                changes you make before <br />
                closing the wizard.
            </span>
            {systemMode === SYSTEM_MODES.ON_PREM && (
                <span className="bg-sf-light-100 py-3 px-4 rounded-lg mt-[30px]">
                    Got a system backup file? Upload it now (Monitor → System Status) to skip the setup wizard.
                </span>
            )}
        </div>
    );
};

export default React.memo(WizardWelcome);
